import React, { useState } from "react";
import { Button, Checkbox, Input, Popover, TextArea } from "../../../BP2Components";

import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "../../../../appRedux/actions/Boards";
import IntlMessages from "../../../../util/IntlMessages";
import { FormattedMessage } from "react-intl";

import button_end_modal_title_example from "../../../../assets/bp2/button_end_modal_title_example.png";
import button_end_modal_content_example from "../../../../assets/bp2/button_end_modal_content_example.png";
import button_end_modal_close_example from "../../../../assets/bp2/button_show_modal_close_example.png";
import button_end_modal_content_button from "../../../../assets/bp2/button_end_modal_save_and_refresh_example.png";

import "../../../../components/Widgets/ButtonWidget/ButtonEndModal.less";

interface ButtonEndModalSettingsProps {
   props: any;
   value: any;
   data: any;
}

const ButtonEndModalSettings: React.FC<ButtonEndModalSettingsProps> = (props) => {
   const [settings, setSettings] = useState({
      ...props.value
   });

   const dispatch = useDispatch();

   const handleInputChange = (fieldName, value) => {
      setSettings((prevSettings) => ({
         ...prevSettings,
         [fieldName]: value
      }));
   };

   const handelSaveSettings = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
   };

   return (
      <>
         <form onSubmit={(e) => handelSaveSettings(e)} className="button-end-modal-form-container">
            <div className="form-row">
               <label className="label">
                  <IntlMessages id="button.end.modal.titlekey" />:
               </label>

               <Input
                  type="string"
                  onChange={(e) => handleInputChange("title", e.target.value)}
                  defaultValue={props?.value?.title}
               />
               <div className="form-row__popover">
                  <Popover
                     children={
                        <span className="material-symbols-outlined question-button">help</span>
                     }
                     content={
                        <>
                           <div>
                              klucz tłumaczenia który wyświetli się w zaznaczonym na czerwono
                              miejscu:
                           </div>
                           <img src={button_end_modal_title_example} />
                        </>
                     }
                  />
               </div>
            </div>
            <div className="form-row">
               <label className="label">
                  <IntlMessages id="button.end.modal.contentkey" />:
               </label>
               <Input
                  type="string"
                  onChange={(e) => handleInputChange("description", e.target.value)}
                  defaultValue={props?.value?.description}
               />
               <div className="form-row__popover">
                  <Popover
                     children={
                        <span className="material-symbols-outlined question-button">help</span>
                     }
                     content={
                        <>
                           <div>
                              klucz tłumaczenia który wyświetli się w zaznaczonym na czerwono
                              miejscu:
                           </div>
                           <img src={button_end_modal_content_example} />
                        </>
                     }
                  />
               </div>
            </div>
            <div className="form-row">
               <label className="label">
                  <IntlMessages id="button.end.modal.closeButtonKey" />:
               </label>
               <Input
                  type="string"
                  onChange={(e) => handleInputChange("closeButtonTitle", e.target.value)}
                  defaultValue={props?.value?.closeButtonTitle}
               />
               <div className="form-row__popover">
                  <Popover
                     children={
                        <span className="material-symbols-outlined question-button">help</span>
                     }
                     content={
                        <>
                           <div>
                              klucz tłumaczenia który wyświetli się w zaznaczonym na czerwono
                              miejscu. Przycisk zamyka modal i nie wykonuje żadnych dodatkowych
                              akcji.
                           </div>
                           <img src={button_end_modal_close_example} />
                        </>
                     }
                  />
               </div>
            </div>
            <div className="form-row">
               <label className="label">
                  <IntlMessages id="button.end.modal.contentButtonKey" />:
               </label>
               <Input
                  type="string"
                  onChange={(e) => handleInputChange("customButtonTitle", e.target.value)}
                  defaultValue={props?.value?.customButtonTitle}
               />
               <div className="form-row__popover">
                  <Popover
                     children={
                        <span className="material-symbols-outlined question-button">help</span>
                     }
                     content={
                        <>
                           <div>
                              klucz tłumaczenia który wyświetli się w zaznaczonym na czerwono
                              przycisku treści. Przycisk po kliknięciu lewym przyciskiem myszki
                              otworzy nam podaną w polu niżej stronę. Jeśli podana strona to
                              bierząca strona - odświeży ją. Po kliknięciu prawym przyciskiem myszy,
                              otworzy wskazany niżej adres w nowej zakładce.
                           </div>
                           <img src={button_end_modal_content_button} />
                        </>
                     }
                  />
               </div>
            </div>
            <div className="form-row">
               <label className="label">
                  <IntlMessages id="button.end.modal.customButtonUrlKey" />:
               </label>
               <Input
                  type="string"
                  onChange={(e) => handleInputChange("customButtonUrl", e.target.value)}
                  defaultValue={props?.value?.customButtonUrl}
               />
               <div className="form-row__popover">
                  <Popover
                     children={
                        <span className="material-symbols-outlined question-button">help</span>
                     }
                     content={
                        <>
                           <div>
                              Adres pod który użytkownik zostanie przekierowany za pomocą przycisku
                              treści
                           </div>
                        </>
                     }
                  />
               </div>
            </div>
            <div className="form-row">
               <label className="label">
                  <IntlMessages id="button.end.modal.dontShowModal" />:
               </label>
               <Checkbox
                  className="checkbox"
                  onChange={(e) => handleInputChange("showEndingModal", e.target.checked)}
                  defaultChecked={props?.value?.showEndingModal}
               />
               <div className="form-row__popover">
                  <Popover
                     children={
                        <span className="material-symbols-outlined question-button">help</span>
                     }
                     content={
                        <div>
                           zarządza widocznością okna modalnego. Zaznaczone oznacza brak okna
                           modalnego.
                        </div>
                     }
                  />
               </div>
            </div>
            <div style={{ marginTop: 20 }}>
               <Button className="save-button" htmlType="submit" buttonType="primary">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default ButtonEndModalSettings;
